import {Validators} from '@angular/forms';

import {PaymentMethodsEnum, PaymentStatusesEnum} from '@spa/api';

import {BaseControl, Helper, RadioGroupControl, SelectControl} from '../../app/shared/classes';
import {RadioGroupOptionInterface} from '../../app/shared/components';
import {ColorCodesEnum, ComponentTypesEnum} from '../../app/shared/enums';

export const TransactionStatusSelector = 'transactionStatus';
export const TransactionNoteSelector = 'transactionNote';

export const PaymentStatusesControl = (): RadioGroupControl => {
    return new RadioGroupControl({
        name: TransactionStatusSelector,
        value: null,
        placeholder: 'Status',
        validators: [
            Validators.required
        ],
        componentType: ComponentTypesEnum.RadioGroup,
        invalid: false,
        errors: [],
        options: []
    });
};
export const BulkPaymentStatusesControls = (): BaseControl[] => [
    new SelectControl({
        name: TransactionStatusSelector,
        value: null,
        placeholder: 'Status',
        validators: [Validators.required],
        componentType: ComponentTypesEnum.Select,
        options: []
    }),
    new BaseControl({
        name: TransactionNoteSelector,
        value: null,
        placeholder: 'Note',
        validators: [],
        componentType: ComponentTypesEnum.Textarea
    }),
];

export const PaymentStatusControlFundingOptions = (): RadioGroupOptionInterface[] => {
    return [
        {
            label: Helper.textsHelper().getPaymentStatusName(
                PaymentStatusesEnum.New
            ),
            value: PaymentStatusesEnum.New,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getPaymentStatusName(
                PaymentStatusesEnum.Pending
            ),
            value: PaymentStatusesEnum.Pending,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getPaymentStatusName(
                PaymentStatusesEnum.ForApproval
            ),
            value: PaymentStatusesEnum.ForApproval,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getPaymentStatusName(
                PaymentStatusesEnum.OnHold
            ),
            value: PaymentStatusesEnum.OnHold,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getPaymentStatusName(
                PaymentStatusesEnum.Approved
            ),
            value: PaymentStatusesEnum.Approved,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getPaymentStatusName(
                PaymentStatusesEnum.Processed
            ),
            value: PaymentStatusesEnum.Processed,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getPaymentStatusName(
                PaymentStatusesEnum.Rejected
            ),
            value: PaymentStatusesEnum.Rejected,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getPaymentStatusName(
                PaymentStatusesEnum.Completed
            ),
            value: PaymentStatusesEnum.Completed,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getPaymentStatusName(
                PaymentStatusesEnum.CanceledByClient
            ),
            value: PaymentStatusesEnum.CanceledByClient,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getPaymentStatusName(
                PaymentStatusesEnum.Canceled
            ),
            value: PaymentStatusesEnum.Canceled,
            color: ColorCodesEnum.Primary
        },
    ];
};

export const PaymentStatusControlWithdrawalOptions = (paymentMethod?: number): RadioGroupOptionInterface[] => {
    const options: RadioGroupOptionInterface[] = [
        {
            label: Helper.textsHelper().getPaymentStatusName(
                PaymentStatusesEnum.ForApproval
            ),
            value: PaymentStatusesEnum.ForApproval,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getPaymentStatusName(
                PaymentStatusesEnum.OnHold
            ),
            value: PaymentStatusesEnum.OnHold,
            color: ColorCodesEnum.Primary
        },
    ];

    if (paymentMethod === PaymentMethodsEnum.Crypto) {
        options.push(
            {
                label: Helper.textsHelper().getPaymentStatusName(
                    PaymentStatusesEnum.ApprovedByOperator
                ),
                value: PaymentStatusesEnum.ApprovedByOperator,
                color: ColorCodesEnum.Primary
            },
            {
                label: Helper.textsHelper().getPaymentStatusName(
                    PaymentStatusesEnum.Processing
                ),
                value: PaymentStatusesEnum.Processing,
                color: ColorCodesEnum.Primary
            },
        );
    }

    options.push(
        {
            label: Helper.textsHelper().getPaymentStatusName(
                PaymentStatusesEnum.Approved
            ),
            value: PaymentStatusesEnum.Approved,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getPaymentStatusName(
                PaymentStatusesEnum.Completed
            ),
            value: PaymentStatusesEnum.Completed,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getPaymentStatusName(
                PaymentStatusesEnum.CanceledByClient
            ),
            value: PaymentStatusesEnum.CanceledByClient,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getPaymentStatusName(
                PaymentStatusesEnum.Canceled
            ),
            value: PaymentStatusesEnum.Canceled,
            color: ColorCodesEnum.Primary
        },
    );

    return options;
};
